export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    paymentList: [
      // {
      //   idx: 0,
      //   name: "",
      //   col: 1,
      //   row: 1,
      //   icoCss: "",
      //   code: "",
      //   isSmall: false,
      // },
      {
        idx: 1,
        name: "신용카드",
        col: 1,
        row: 2,
        icoCss: "ico-card",
        code: "PAY001",
        isSmall: false,
      },
      {
        idx: 2,
        name: "현금",
        col: 1,
        row: 2,
        icoCss: "ico-cash",
        code: "PAY004",
        isSmall: false,
      },
      {
        idx: 3,
        name: "복합 결제",
        col: 1,
        row: 2,
        icoCss: "ico-multi",
        code: "PAY002",
        isSmall: false,
      },
      {
        idx: 4,
        name: "상품별 결제",
        col: 1,
        row: 1,
        icoCss: "",
        code: "PAY006",
        isSmall: true,
      },
      {
        idx: 5,
        name: "영수증 관리",
        col: 1,
        row: 1,
        icoCss: "",
        code: "PAY007",
        isSmall: true,
      },
      {
        idx: 6,
        name: "더치페이",
        col: 1,
        row: 1,
        icoCss: "",
        code: "PAY008",
        isSmall: false,
      },
      {
        idx: 7,
        name: "클레임",
        col: 1,
        row: 1,
        icoCss: "",
        code: "PAY009",
        isSmall: false,
      },
    ],
  },
};
